import { render } from "./TextToSpeechUploader.vue?vue&type=template&id=6d72a2a4"
import script from "./TextToSpeechUploader.vue?vue&type=script&lang=js"
export * from "./TextToSpeechUploader.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__